import { createFileRoute } from '@tanstack/react-router';

import { ForgotPasswordForm } from './-components/forgot-password-form';

export const Route = createFileRoute('/_auth/forgot-password/')({
  component: RouteComponent,
  head: () => ({
    meta: [{ title: 'FeatureBuddy - Forgot Password' }],
  }),
});

function RouteComponent() {
  return (
    <div>
      <ForgotPasswordForm />
    </div>
  );
}
